const dayNumber = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/.exec(String(value || ""));
  if (!match) return null;
  const [, year, month, day] = match.map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
  return date.getTime() / 86400000;
};

export const hasCertificateExpiry = (row) => dayNumber(row?.expire_at) !== null;

export const getCertificateStatus = (row, now = new Date()) => {
  const expiry = dayNumber(row?.expire_at);
  if (expiry === null) return [0, 1, 2].includes(Number(row?.status)) ? Number(row.status) : 0;
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / 86400000;
  const remaining = expiry - today;
  return remaining < 0 ? 2 : remaining <= 30 ? 1 : 0;
};
